var map = {
	"./bfs/app/navbar/expandable-navbar-section/expandable-navbar-section.component": [
		98940,
		"src_themes_bfs_app_navbar_expandable-navbar-section_expandable-navbar-section_component_ts"
	],
	"./custom/app/navbar/expandable-navbar-section/expandable-navbar-section.component": [
		61754,
		"src_themes_custom_app_navbar_expandable-navbar-section_expandable-navbar-section_component_ts"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 88289;
module.exports = webpackAsyncContext;